export const FEATURES_LAND = ['road', 'electricity', 'water', 'sewage', 'drain', 'fireSafety', 'internet'];
